import { log, supabase } from ".";
import {
  CAMPOS_SENSIBLES_MES,
  cambioRequiereRecaptura,
  capturarSnapshotDesdeContrato,
  eliminarSnapshotsContratoMeses,
  traceSnapshot,
} from "./comisionSnapshot";

// Devuelve { data, snapshotFallo }: el update del contrato SIEMPRE se aplica; `snapshotFallo=true`
// avisa que la re-captura de la foto de comisión de algún mes falló (10.177 — no silencioso).
export const updateContrato = async ({ id, contrato }) => {
  try {
    // Estado previo (para detectar qué mes cambió en campos sensibles)
    let antes = null;
    try {
      const prev = await supabase.select("sales_contratos", { filters: { id } });
      antes = prev && prev[0];
    } catch (prevErr) {
      log.error("updateContrato/antes", prevErr);
    }

    const data = await supabase.update("sales_contratos", contrato, id);

    if (!data || data.length === 0) throw new Error("Empty response");

    // Espejo ADITIVO hacia `oportunidades` — mismo criterio que `updateOportunidad.js` (Fase E
    // Commit 2, 2026-09-26, decisión de Ignacio; ver ese archivo para el detalle completo).
    if (antes?.oportunidad_id != null && contrato.estatus != null) {
      try {
        await supabase.update("oportunidades", { estatus: contrato.estatus }, antes.oportunidad_id);
      } catch (oppErr) {
        log.error("updateContrato/espejo_oportunidad", oppErr);
      }
    }

    // Re-captura ADITIVA: SOLO los meses cuyos campos sensibles cambiaron. Si falla, no aborta,
    // pero deja traza + flag (10.177).
    let snapshotFallo = false;
    try {
      if (antes) {
        const despues = { ...antes, ...contrato };
        const mesesAntes = Object.fromEntries((antes.meses || []).map((m) => [m.mes, m]));
        const mesesCambiados = (despues.meses || []).filter((m) =>
          cambioRequiereRecaptura(mesesAntes[m.mes] || {}, m, CAMPOS_SENSIBLES_MES)
        );
        if (mesesCambiados.length > 0) {
          // Re-captura solo esos meses (keyed por (contrato_id, mes)); el resto queda intacto.
          // Defensa en profundidad: fijar el `id` CONOCIDO del contrato → nunca se mis-keyea.
          await capturarSnapshotDesdeContrato({ ...despues, id, meses: mesesCambiados }, "modificacion");
        }
        // CABO 2: meses que existían antes y ya no → borrar su foto (evita huérfanas).
        const mesesDespuesSet = new Set((despues.meses || []).map((m) => m.mes));
        const mesesEliminados = Object.keys(mesesAntes).filter((mes) => !mesesDespuesSet.has(mes));
        if (mesesEliminados.length > 0) {
          await eliminarSnapshotsContratoMeses(id, mesesEliminados);
        }
      }
    } catch (snapErr) {
      snapshotFallo = true;
      traceSnapshot("recaptura_edit_fallo", {
        origenTipo: "contrato_mes",
        contratoId: id,
        error: String(snapErr?.message || snapErr),
      });
      log.error("updateContrato/snapshot", snapErr);
    }

    return { data, snapshotFallo };
  } catch (error) {
    log.error("updateContrato", error);
    throw error;
  }
};
